module.exports = __webpack_public_path__ + "img/4e4f22b554b2b135721690558b3a89a8.png";